import React from "react";
import { Row, Col, Button, Form } from "react-bootstrap";
import Select from "react-select";
import { useScopeTypes } from "../../../hooks/useScopeTypes";
import { PermissionWrapper } from "../../PermissionWrapper/PermissionWrapper";
import DebouncedSearchInput from "../../common/DebouncedSearchInput";

const CREATED_BY_OPTIONS = [
  { value: "", label: "All" },
  { value: "System", label: "System" },
  { value: "admin_user_1", label: "Admin" },
];

interface RolesFiltersProps {
  onCreateRoleClick?: () => void;
  onSearchChange?: (value: string) => void;
  onScopeTypeChange?: (value: string) => void;
  searchValue?: string;
  scopeTypeValue?: string;
}

const RolesFilters: React.FC<RolesFiltersProps> = ({
  onCreateRoleClick,
  onSearchChange,
  onScopeTypeChange,
  searchValue = "",
  scopeTypeValue = "",
}) => {
  const { scopeTypeFilterOptions } = useScopeTypes();

  return (
    <Row className="g-2 justify-content-md-end align-items-end flex-nowrap">
      <Col xs={12} md={5} className="min-w-0">
        <DebouncedSearchInput
          value={searchValue}
          onChange={(val) => onSearchChange?.(val)}
          placeholder="Search by role name"
        />
      </Col>
      <Col xs={6} md={3} className="flex-shrink-0">
        <Form.Label
          className="mb-1 text-muted"
          style={{ fontSize: 11 }}
        >
          Scope Type
        </Form.Label>
        <Select
          classNamePrefix="react-select"
          value={
            scopeTypeFilterOptions.find((opt) => opt.value === scopeTypeValue) ??
            scopeTypeFilterOptions[0]
          }
          onChange={(option) => onScopeTypeChange?.(option?.value ?? "")}
          options={scopeTypeFilterOptions}
          isClearable={false}
        />
      </Col>
      <Col
        xs={12}
        md="auto"
        className="flex-shrink-0 text-md-end d-flex align-items-stretch"
      >
        <PermissionWrapper
          anyOfPermissions={[
            "access_management.admin",
            "access_management.roles.manage",
          ]}
          hideWhenDisabled
        >
          <Button
            variant="primary"
            className="w-100 d-flex align-items-center justify-content-center"
            style={{ height: 45 }}
            onClick={onCreateRoleClick}
          >
            + Create Role
          </Button>
        </PermissionWrapper>
      </Col>
    </Row>
  );
};

export default RolesFilters;
